import { Grid, Paper, TextField } from "@mui/material";

import { AuthServices } from "services";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import useAlert from "hooks/useAlert";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import useToken from "hooks/useToken";
import withNotAuth from "hocs/withNotAuth";

type FormData = {
  username: string;
  password: string;
};

const Login = () => {
  const navigate = useNavigate();
  const { onAlert } = useAlert();
  const { setToken } = useToken();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>();

  const onSubmit = handleSubmit((data) => {
    AuthServices.login({
      username: data.username,
      password: data.password,
    })
      .then((res) => {
        setToken(res.data.token);
        onAlert("success", "Login success");
        navigate("/dashboard");
      })
      .catch((err) => {
        onAlert("error", err.response.data.message);
      });
  });

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{
        height: "100vh",
      }}
    >
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          p: 5,
          maxWidth: "450px",
        }}
      >
        <img
          src="/logo.png"
          alt="logo"
          style={{
            width: "100px",
            height: "100px",
            objectFit: "contain",
            marginRight: "10px",
            borderRadius: "50px",
            marginBottom: "20px",
          }}
        />
        <Typography component="h1" variant="h5" style={{ fontWeight: "bold" }}>
          LINE OA Management
        </Typography>
        <Box sx={{ mt: 3 }}>
          <form onSubmit={onSubmit}>
            <TextField
              fullWidth
              label="Phone Number"
              type="text"
              {...register("username", {
                required: "กรุณากรอกเบอร์โทรศัพท์",
              })}
              error={!!errors.username?.message}
              helperText={errors.username?.message}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              {...register("password", { required: "กรุณากรอกรหัสผ่าน" })}
              error={!!errors.password?.message}
              helperText={errors.password?.message}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3 }}
              size="large"
            >
              Log In
            </Button>
          </form>
        </Box>
      </Paper>
    </Grid>
  );
};

export default withNotAuth(Login);
